// extracted by mini-css-extract-plugin
export default {"blockingCriteriaPanel":"blocking-criteria-panel_blockingCriteriaPanel__+2wwS"};